import Select from "../../../form/input/select";
import React from "react";
import {useTranslation} from "next-i18next";

/**
 *
 */
type Data = {
    id : string
    defaultValue : string
}

/**
 *
 * @param id
 * @param defaultValue
 * @constructor
 */
export default function Type({ id, defaultValue } : Data) {
    // init
    const { t } = useTranslation();

    // init options
    const options = [
        {key: "default", value: "", display: t('choose.type'), disabled: true},
        {key: "front", value: "front", display: t('front'), disabled: false},
        {key: "back", value: "back", display: t('back'), disabled: false},
        {key: "left", value: "left", display: t('left'), disabled: false},
        {key: "right", value: "right", display: t('right'), disabled: false},
        {key: "bottom", value: "bottom", display: t('bottom'), disabled: false},
        {key: "top", value: "top", display: t('top'), disabled: false},
        {key: "quantity", value: "quantity", display: t('quantity'), disabled: false},
        {key: "ingredients", value: "ingredients", display: t('ingredients'), disabled: false},
        {key: "nutrients", value: "nutrients", display: t('nutrients'), disabled: false},
        {key: "nutriscore", value: "nutriscore", display: t('nutriscore'), disabled: false},
        {key: "novagroup", value: "novagroup", display: t('novagroup'), disabled: false},
        {key: "certificates", value: "certificates", display: t('certificates'), disabled: false},
        {key: "packaging", value: "packaging", display: t('packaging'), disabled: false},
        {key: "brand", value: "brand", display: t('brand'), disabled: false},
        {key: "unknown", value: "unknown", display: t('unknown'), disabled: false}
    ];

    // render
    return (
        <Select
            id={'image-type-' + id}
            name={'images_type[]'}
            defaultValue={defaultValue}
            options={options}
        />
    );
}